import { clientTimeline } from './types';

export const requestClientTimeline = (entityId, promise) => ({
  type: clientTimeline.request,
  entityId,
  promise,
});

export const requestClientTimelineSuccess = (response) => ({
  type: clientTimeline.success,
  response,
});

export const requestClientTimelineFailure = (response) => ({
  type: clientTimeline.failure,
  response,
});
